import React from "react";
import Highcharts from "highcharts";
import Wordcloud from "highcharts/modules/wordcloud.js";
import HighchartsReact from "highcharts-react-official";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas } from "../utils";
import { roboto } from "../fontFile";

Wordcloud(Highcharts);
HighchartsCustomEvents(Highcharts);

class WordcloudChart extends React.PureComponent {
    state = {
        selectedWord: [],
    };
    chartComponent = React.createRef();

    componentDidUpdate(prevProps) {
        if (this.props.hasDrilldownWords !== prevProps.hasDrilldownWords && this.chartComponent?.current) {
            this.chartComponent.current.chart.reflow();
        }
        if (this.props.selectedWord.length !== prevProps.selectedWord.length && this.chartComponent?.current) {
            this.chartComponent.current.chart.reflow();
            this.chartComponent.current.chart.update(this.getOptions(this.getData()));
        }
    }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current && this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getData = () => {
        let dataRender = this.props.data;

        if (this.props.selectedWord.length > 0) {
            dataRender = JSON.parse(JSON.stringify(dataRender)).map((d) => {
                if (this.props.selectedWord.includes(d.name)) {
                    d.className = "highcharts-point-selected-to-be-deleted";
                } else d.className = null;
                return d;
            });
        } else {
            dataRender = JSON.parse(JSON.stringify(dataRender)).map((d) => {
                d.className = null;
                return d;
            });
        }
        return dataRender;
    };

    getOptions = (data) => {
        let self = this;

        let aggs = this.props.appliedFilter.aggs;

        const options = {
            chart: {
                // height: 500,
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    // fontSize: 12,
                    spacingBottom: 0,
                    spacingTop: 0,
                    spacingLeft: 0,
                    spacingRight: 0,
                },
                events: {
                    load: function (event) {
                        if (this.props?.pngDownload) {
                            let style = document.createElement("style");
                            style.appendChild(document.createTextNode(roboto));
                            const element = document.getElementById(event.target.container.id).firstChild;
                            element.insertBefore(style, element.firstChild);
                        }
                    },
                },
            },
            colorAxis: {
                min: 0,
                max: 30,
            },
            series: [
                {
                    type: "wordcloud",
                    data,
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        //color: "blue",
                        //textDecoration: "line-through"
                    },
                    rotation: {
                        from: 0,
                        to: 0,
                        // orientations: 45,
                    },
                },
            ],
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                wordcloud: {
                    cropThreshold: 0,
                    minFontSize: 10,
                    // maxFontSize: 14,
                    // allowPointSelect: false,
                    // states: {
                    //     select: {
                    //         color: "red",
                    //     },
                    // },
                    point: {
                        events: {
                            click: function (e) {
                                if (!self.props.selectedWord.includes(this.name)) {
                                    self.props.drillDown(this.name);
                                }
                            },
                            contextmenu: function (e) {
                                e.preventDefault();
                                let type = "delete";
                                if (self.props.selectedWord.includes(this.name)) {
                                    type = "add";
                                }
                                self.props.showContextMenu(e.x, e.y, this.name, type);
                            },
                        },
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                outside: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: "normal",
                    zIndex: 2000,
                },
                formatter: function () {
                    // if (this.point.options.className) return;
                    // console.log(this);
                    return `<span>${numberWithCommas(this.point.options.weight)} ${aggs === "frequency-wordcloud" ? "MENTIONS" : "IMPACT"}</span>`;
                },
            },
        };

        return options;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions(this.getData())}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: this.props.hasDrilldownWords ? "calc(100% - 30px)" : "100%" } }}
            />
        );
    }
}

export default WordcloudChart;
